import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'hf-custom-switch-toggle',
  templateUrl: './custom-switch-toggle.component.html',
  styleUrls: ['./custom-switch-toggle.component.scss']
})
export class CustomSwitchToggleComponent {
  @Input() public group: UntypedFormGroup;
  @Input() public label: string;
  @Input() public inputFormControlName: string;
  @Input() public checked: boolean;
  @Input() public hasBackground: boolean = true;
}
